import React, { useMemo } from 'react';

type PropsType = {
  label: string;
  onClick: () => void;
  isLight?: boolean;
  isMedium?: boolean;
};

const MessageButton = ({ label, onClick, isLight, isMedium }: PropsType) => {
  const buttonStyleAttributes = useMemo(
    () => `${isLight ? 'action-light' : 'action'} full-width ${isMedium ? 'medium' : ''}`,
    [isMedium],
  );

  return (
    <button
      type="button"
      data-wx-button={buttonStyleAttributes}
      title={label}
      aria-label={label}
      onClick={onClick}
    >
      <i className="icon-message m-r-half" />
      {label}
    </button>
  );
};

export default MessageButton;
